import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Dropdown,
  ProgressBar,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom"; // 🆕 ADD THIS
import api from "../api";
import { toast } from "react-toastify";
import { exportDistrictData } from "./exportFile";

const MonthlyUploadDashboard = ({ refresh }) => {
  const navigate = useNavigate(); // 🆕 ADD THIS
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().toLocaleString("default", { month: "long" });

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const years = Array.from({ length: 2 }, (_, i) =>
    (currentYear - i).toString(),
  );

  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear.toString());
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalUploads, setTotalUploads] = useState(0);
  const [totalTarget, setTotalTarget] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);

  useEffect(() => {
    fetchUploadProgress();
  }, [month, year, refresh]);
  const fetchUploadProgress = async () => {
    setLoading(true);
    try {
      const response = await api.post("/upload-status", {
        Month: month,
        Year: parseInt(year),
      });

      const responseData = response.data;
      const currentUser = JSON.parse(localStorage.getItem("user"));

      let assignedStates = currentUser?.assigned_state;
      console.log("CUREEENT:", assignedStates);

      if (typeof assignedStates === "string") {
        try {
          assignedStates = JSON.parse(assignedStates);
        } catch {
          assignedStates = [];
        }
      }

      const normalizeState = (value) => value?.toString().trim().toLowerCase();

      const allStatesAccess =
        assignedStates === null ||
        !Array.isArray(assignedStates) ||
        assignedStates.length === 0;

      const assignedStateSet = new Set(
        (assignedStates || []).map(normalizeState),
      );

      const filteredStateWiseStatus = allStatesAccess
        ? responseData.state_wise_status || []
        : (responseData.state_wise_status || []).filter((item) =>
            assignedStateSet.has(normalizeState(item.state)),
          );
      setTotalUploads(responseData.current_count || 0);
      setTotalTarget(responseData.total_cities || 0);
      // setData(responseData.state_wise_status || []);
      setData(filteredStateWiseStatus);
    } catch (error) {
      console.error("Error fetching upload progress:", error);
      if (error.response?.status === 400) {
        toast.warning(error.response.data.error || "No data found");
        setData([]);
        setTotalUploads(0);
        setTotalTarget(0);
      } else {
        toast.error("Failed to fetch upload progress");
      }
    } finally {
      setLoading(false);
    }
  };

  // 🆕 ADD THIS FUNCTION
  const handleStateClick = (stateName) => {
    navigate("/state-details", {
      state: { state: stateName, month: month, year: year },
    });
  };

  const getUserAssignedStatesForRequest = () => {
    const currentUser = JSON.parse(localStorage.getItem("user"));

    let assignedStates = currentUser?.assigned_state;

    if (typeof assignedStates === "string") {
      try {
        assignedStates = JSON.parse(assignedStates);
      } catch {
        assignedStates = null;
      }
    }

    const allStatesAccess =
      assignedStates === null ||
      !Array.isArray(assignedStates) ||
      assignedStates.length === 0;
    console.log("STATEEEE:", assignedStates);
    return allStatesAccess ? "ALL_STATE" : assignedStates;
  };
  const handleExport = async () => {
    if (exportLoading) return; // prevent double click

    setExportLoading(true);

    const toastId = toast.loading(
      "⏳ Please wait... Export is in progress. This may take longer.",
    );

    try {
      const result = await exportDistrictData({
        Year: year,
        Month: month,
        // State: ["Assam", "Arunachal Pradesh"],
        State: getUserAssignedStatesForRequest(),
      });
      console.log("IN EXO", result);

      // If backend sends "no data"
      if (!result || result.noData) {
        toast.dismiss(toastId);
        // toast.update(toastId, {
        //   render: "⚠️ No data available for selected period.",
        //   type: "warning",
        //   isLoading: false,
        //   autoClose: 3000,
        // });
      } else {
        toast.dismiss(toastId);
        // toast.update(toastId, {
        //   render: "✅ Export completed successfully!",
        //   type: "success",
        //   isLoading: false,
        //   autoClose: 3000,
        // });
      }
    } catch (error) {
      console.error("Export failed:", error);

      toast.update(toastId, {
        render: "❌ Export failed. Please try again.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setExportLoading(false);
    }
  };

  const overallProgress =
    totalTarget > 0 ? ((totalUploads / totalTarget) * 100).toFixed(1) : "0.0";

  return (
    <Container
      fluid
      className="p-4 shadow-lg"
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        borderRadius: "7px",
      }}
    >
      {/* Header Section */}
      <Card
        className="p-4 mb-4"
        style={{ borderRadius: "12px", background: "#f2f4fb" }}
      >
        <Row className="align-items-center">
          <Col md={8}>
            <h4 className="fw-bold text-dark mb-1">📊 Monthly Dashboard</h4>
            <p className="text-secondary mb-0">
              Reporting Period: {month} {year}
            </p>
          </Col>
          <Col md={4} className="text-md-end mt-3 mt-md-0">
            <Dropdown className="d-inline me-2">
              <Dropdown.Toggle variant="light" className="shadow-sm rounded">
                {month}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                {months.map((m) => (
                  <Dropdown.Item
                    key={m}
                    onClick={() => setMonth(m)}
                    active={m === month}
                  >
                    {m}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown className="d-inline">
              <Dropdown.Toggle variant="light" className="shadow-sm rounded">
                {year}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {years.map((y) => (
                  <Dropdown.Item
                    key={y}
                    onClick={() => setYear(y)}
                    active={y === year}
                  >
                    {y}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <button
              className="btn btn-success shadow-sm rounded ms-2"
              onClick={handleExport}
              disabled={exportLoading}
            >
              {exportLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Exporting...
                </>
              ) : (
                "Export Data"
              )}
            </button>
          </Col>
        </Row>
      </Card>

      {/* Summary Cards */}
      <Row className="g-3 mb-4">
        <Col md={4}>
          <Card
            className="text-center shadow-sm border-0"
            style={{ borderRadius: "12px", background: "#f2f4fb" }}
          >
            <Card.Body>
              <h6 className="text-muted">Total Uploads</h6>
              <h4 className="fw-bold">{totalUploads}</h4>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card
            className="text-center shadow-sm border-0"
            style={{ borderRadius: "12px", background: "#f2f4fb" }}
          >
            <Card.Body>
              <h6 className="text-muted">Target</h6>
              <h4 className="fw-bold">{totalTarget}</h4>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card
            className="text-center shadow-sm border-0"
            style={{ borderRadius: "12px", background: "#f2f4fb" }}
          >
            <Card.Body>
              <h6 className="text-muted">Overall Progress</h6>
              <h4 className="fw-bold">{overallProgress}%</h4>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Table Section */}
      <Card
        className="shadow-sm border-0"
        style={{ borderRadius: "12px", background: "#f2f4fb" }}
      >
        <Card.Body>
          <h5 className="fw-bold mb-3">State-wise Upload Summary</h5>

          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
              <p className="mt-3 text-muted">Loading data...</p>
            </div>
          ) : data.length === 0 ? (
            <div className="text-center py-5">
              <i className="bi bi-inbox display-1 text-muted"></i>
              <p className="mt-3 text-muted">
                No upload data available for {month} {year}
              </p>
            </div>
          ) : (
            <Table hover responsive className="align-middle">
              <thead>
                <tr>
                  <th>STATE</th>
                  <th>UPLOADS</th>
                  <th>TARGET</th>
                  <th>PROGRESS</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, idx) => {
                  const uploads = row.current_count || 0;
                  const target = row.city_count || 0;
                  const progress =
                    target > 0 ? Math.round((uploads / target) * 100) : 0;

                  return (
                    <tr
                      key={idx}
                      onClick={() => handleStateClick(row.state)} // 🆕 ADD THIS
                      style={{ cursor: "pointer" }} // 🆕 ADD THIS
                    >
                      <td className="fw-semibold">{row.state}</td>
                      <td>{uploads}</td>
                      <td>{target}</td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <ProgressBar
                            now={Math.min(progress, 100)}
                            style={{
                              flex: 1,
                              height: "8px",
                              borderRadius: "10px",
                            }}
                            variant={
                              progress === 100
                                ? "success"
                                : progress >= 50
                                  ? "warning"
                                  : "secondary"
                            }
                          />
                          <span
                            className="small fw-semibold"
                            style={{ minWidth: "40px" }}
                          >
                            {progress}%
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default MonthlyUploadDashboard;
